import { EmptyState } from '@myhome/ui/patterns/empty-state';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_shell/content')({
  component: Page,
});

function Page() {
  return (
    <div className="flex flex-col gap-5">
      <h1 className="font-heading text-headline font-semibold text-navy-900">Content</h1>
      <EmptyState
        title="Content"
        description="Articles, offers, competitions and ad banners arrive with the content feature."
      />
    </div>
  );
}
